export default __webpack_public_path__ + "static/media/AddNew.3ddd8e93.svg";